"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const searchUserByRegistrationCode = (0, graphql_tag_1.default)`
  query registration_searchUserByRegistrationCode($code: String!) {
    registration {
      searchUserByRegistrationCode(code: $code) {
        email
        phone
        fullName
        invitedToRole
        hoa {
          structureType
          housesType
          code
          name
          id
          phoneRegistrationIsAvailable
          hoaHouses {
            id
            entrancesAmount
            floorsAmount
            maxAreaSize
            maxApartmentsAmount
            street
            streetType
            house
            unit
            unitType
            pavilion
            streetFiasId
            houseFiasId
          }
          address {
            country
            region
            regionType
            zip
            city
            cityType
            street
            streetType
            house
            unit
            unitType
            pavilion
            storey
            entrance
            apartment
            area
            areaType
            cityArea
            cityDistrict
            cityDistrictType
          }
        }
      }
    }
  }
`;
exports.default = searchUserByRegistrationCode;